import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import io from "socket.io-client";

// core components
import Navbar from "../layouts/Navbar.js";
import Footer from "../layouts/Footer.js";

import '../../assets/css/Board.css'

import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Table,
  Button
} from "reactstrap";

import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

// Fontawesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";

export default function ServerState() {

  const [isLoading, setIsLoading] = useState(false);
  const [containerStates, setContainerStates] = useState([]);
  const [logs, setLogs] = useState({
    '/lsim_app': [],
    '/lsis_web': [],
    '/lsps_app': [],
    '/eph_logger': [],
  });

  const containerRef = useRef(null);
  const scrollbarRef = useRef(null);

  useEffect(() => {
    if (containerRef.current && !scrollbarRef.current) {
      scrollbarRef.current = new PerfectScrollbar(containerRef.current);
    } else if (scrollbarRef.current) {
      scrollbarRef.current.update();
    }
  }, [logs]);

  const socketRef = useRef(null);

  useEffect(() => {
    getContainerStates();
    initializeSocket();

    return () => {
      if (socketRef.current) {
        socketRef.current.disconnect();
      }
    };
  }, []);
  
  const getContainerStates = async () => {
    try {
        const response = await axios.get(
            `/containers`,
            { baseURL : process.env.REACT_APP_SERVER_URL },
            {
                withCredentials: true,
            }
        );

        if (response.data) {
            console.log(response.data);
            setContainerStates(response.data);
        }
    } catch (error) {
        console.error('Error fetching container states:', error);
    }
};

  const initializeSocket = () => {
    socketRef.current = io( process.env.REACT_APP_SERVER_URL );

    socketRef.current.on('connect', () => {
      console.log('Successfully connected!');
    });

    const containerNames = ['/lsim_app', '/lsis_web', '/lsps_app', '/eph_logger'];

    containerNames.forEach(containerName => {
      socketRef.current.on(`dockerLogs_${containerName}`, (log) => {
        setLogs(prevLogs => ({
          ...prevLogs,
          [containerName]: [...(prevLogs[containerName] || []), log],
        }));
      });
    });
  };

  const requestContainerLogs = (containerName) => {
    if (socketRef.current) {
      socketRef.current.emit('subscribe', containerName);
    }
  };
  
  const handleDisconnect = (containerName) => {
    if (socketRef.current) {
      socketRef.current.emit('unsubscribe', containerName);
    }
  };

  const getContainerByName = (name) => {
    return containerStates.filter(container => container.Names[0] === name).map(container => {
      console.log('Raw Created Timestamp:', container.CreatedTime); // Logging the raw timestamp for debugging
      return [
        container.Names[0],
        container.State,
        //container.CreatedTime,
        new Date(container.CreatedTime).toLocaleString(), // Multiplying by 1000 to convert to milliseconds
        //new Date(container.Created * 1000).toISOString(),
        container.Id,
      ];
    });
  };

  return (
    <div>
      <Navbar />
      
      <div className="wrapper">
        <div className="page-header">
          <div className="page-header-image" />

            <div id="ServerState" className="register-page">
            <div className="Section">
                <div className="cardWithTitle">
                <div className="SectionHeaderFull">
                    <div className="SectionHeaderTxtbox">
                    <div className="SectionHeaderCategory CategoryDark">ServerState</div>
                    <div className="SectionHeaderTitle"></div>
                    <div className="SectionHeaderDescription">
                      Docker Container Monitoring
                    </div>
                    </div>
                </div>
                
                <div className="SectionContents" style={{marginTop:'30px'}}>
                    {/* 게시글 목록 표시 */}
                    {isLoading ? (
                      // 로딩 중일 때 로딩 스피너 또는 메시지 표시
                      <div className="SectionTableContents">
                        <div class="loader">
                          <div class="loader-container">
                            <p class='loader-title'>Loading...</p>
                          </div>
                        </div>
                      </div>
                    ) : (
                    <div className="SectionGridContents">
                          <Card>
                            <CardHeader>
                              <span className="cardCategory">Docker Containers</span>
                              <span className="cardTitle">/example_app</span>
                            </CardHeader>
                            <CardBody>
                            <Table
                                tableHead={["Name", "State", "Created Time", "ID"]}
                                tableData={getContainerByName('/example_app')}
                              />
                            <Table responsive>
                              <thead>
                                  <th>Name</th>
                                  <th>State</th>
                                  <th>Create Time</th>
                                  <th>ID</th>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>Docker Name</td>
                                  <td>Running</td>
                                  <td>{new Date().toLocaleString()}</td>
                                  <td>Docker ID</td>
                                </tr>
                              </tbody>
                            </Table>

                              <div ref={containerRef} className="logContainer">
                                {/* 로그를 <pre> 태그로 표시하여 개행 문자를 올바르게 표시합니다. */}
                                <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
                                  <div className="typo">
                                      <span>
                                      2023-08-01T14:23:45.678Z: Starting application...<br/>
                                      2023-08-01T14:23:46.123Z: Application initialized successfully.<br/>
                                      2023-08-01T14:23:48.456Z: Received incoming request: GET /api/users<br/>
                                      2023-08-01T14:23:48.789Z: Querying database for user data...<br/>
                                      2023-08-01T14:23:49.012Z: Successfully retrieved user data from the database.<br/>
                                      2023-08-01T14:23:50.123Z: Sending response to client: 200 OK<br/>
                                      2023-08-01T14:23:55.321Z: Received incoming request: POST /api/posts<br/>
                                      2023-08-01T14:23:55.789Z: Validating request data...<br/>
                                      2023-08-01T14:23:56.234Z: Request data is valid.<br/>
                                      2023-08-01T14:23:56.456Z: Saving post to the database...<br/>
                                      2023-08-01T14:23:57.123Z: Post saved successfully.<br/>
                                      2023-08-01T14:23:57.567Z: Sending response to client: 201 Created<br/>
                                      2023-08-01T14:24:00.987Z: Application shutdown initiated...<br/>
                                      2023-08-01T14:24:01.234Z: Cleaning up resources...<br/>
                                      2023-08-01T14:24:01.789Z: Application shutdown complete.<br/>
                                      </span>
                                  </div>
                                </pre>
                              </div>
                              <div className="stat-button-area">
                                <Button
                                  color="primary"
                                  onClick={() => requestContainerLogs('/example_app')}
                                >
                                  Fetch Logs
                                </Button>
                                <Button
                                  color="secondary"
                                  onClick={handleDisconnect('/example_app')}
                                >
                                  Disconnect
                                </Button>
                              </div>
                            </CardBody>
                            <CardFooter stats>
                              <div className="stats">
                                <span style={{color:'red'}}>
                                  <FontAwesomeIcon icon={faTriangleExclamation} />
                                </span>
                                <a href="#paul" onClick={(e) => e.preventDefault()}>
                                &nbsp;Current Time: {new Date().toLocaleString()}
                                </a>
                              </div>
                            </CardFooter>
                          </Card>

                      {['/lsim_app', '/lsis_web', '/lsps_app', '/eph_logger'].map(name => (
                          <Card key={name}>
                            <CardHeader>
                              <span className="cardCategory">Docker Containers</span>
                              <span className="cardTitle">{name}</span>
                            </CardHeader>
                            <CardBody>
                            <Table responsive
                                tableHead={["Name", "State", "Created Time", "ID"]}
                                tableData={getContainerByName(name)}
                            />
                              <div ref={containerRef} className="logContainer">
                                {/* 로그를 <pre> 태그로 표시하여 개행 문자를 올바르게 표시합니다. */}
                                <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
                                  <div className="typo">
                                      <h6>{logs[name] ? logs[name].join('\n') : ''}</h6>
                                  </div>
                                </pre>
                              </div>
                              <div className="stat-button-area">
                                <Button
                                  color="primary"
                                  onClick={() => requestContainerLogs(name)}
                                >
                                  Fetch Logs
                                </Button>
                                <Button
                                  color="secondary"
                                  onClick={handleDisconnect(name)}
                                >
                                  Disconnect
                                </Button>
                              </div>
                            </CardBody>
                            <CardFooter stats>
                              <div className="stats">
                                <span style={{color:'red'}}>
                                  <FontAwesomeIcon icon={faTriangleExclamation} />
                                </span>
                                <a href="#paul" onClick={(e) => e.preventDefault()}>
                                &nbsp;Current Time: {new Date().toLocaleString()}
                                </a>
                              </div>
                            </CardFooter>
                          </Card>
                      ))}
                    </div>
                    )}              
                      {/*
                      <div className="board-view-button-area">
                        <div/>
                        <div>
                          <button className="form-button-sm" onClick={(e)=>{e.preventDefault(navigate("/BoardWrite"))}}>신규등록</button>
                        </div>
                      </div>
                      */}
                </div>
                </div>

            </div>
            </div>
          
        </div>
      </div>

      <Footer />
    </div>
  );
};